// extracted by mini-css-extract-plugin
module.exports = {"AreaChart":"AreaChart_AreaChart__wRnCT"};